import { ApplicationController } from "../../support/application-controller";
import queryString from 'query-string';

export default class extends ApplicationController {

    static targets = [
        "loadingIndicator",
    ];

    createNewSubscription() {
        this.loadingIndicatorTarget.classList.remove("hidden");
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState === 4) {
                if (xmlHttp.status === 200) {
                    const response = JSON.parse(xmlHttp.response);
                    window.location.href = response.redirectTo;
                } else {
                    console.warn(xmlHttp.status);
                    console.warn(xmlHttp.response);
                }
            }
        };
        xmlHttp.open("POST", this.createNewUrl);
        xmlHttp.setRequestHeader("Content-Type", "application/json");
        xmlHttp.send(JSON.stringify({}));
    }

    onEditSubscriptionClick(e) {
        // To enable keyboard triggering using enter and space key only
        if (e.keyCode && !(e.keyCode === 13 || e.keyCode === 32)) return;
        e.preventDefault();
        window.location.href = e.target.dataset.editSubscriptionUrl;
    }

    onRenewSubscription(e) {
        const renewUrl = e.target.dataset.subscriptionRenewUrl;

        this.loadingIndicatorTarget.classList.remove("hidden");
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState === 4) {
                if (xmlHttp.status === 200) {
                    const response = JSON.parse(xmlHttp.response);
                    window.open(response.redirectTo);
                    location.reload();
                } else {
                    console.warn(xmlHttp.status);
                    console.warn(xmlHttp.response);
                }
            }
        };
        xmlHttp.open("POST", renewUrl);
        xmlHttp.setRequestHeader("Content-Type", "application/json");
        xmlHttp.send(JSON.stringify({}));
    }

    onMarkSubscriptionAsPaid(e) {
        const markAsPaidUrl = e.target.dataset.subscriptionMarkAsPaidUrl;

        this.loadingIndicatorTarget.classList.remove("hidden");
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState === 4) {
                if (xmlHttp.status === 200) {
                    location.reload();
                } else {
                    console.warn(xmlHttp.status);
                    console.warn(xmlHttp.response);
                }
            }
        };
        xmlHttp.open("POST", markAsPaidUrl);
        xmlHttp.setRequestHeader("Content-Type", "application/json");
        xmlHttp.send(JSON.stringify({}));
    }

    onMarkSubscriptionAsCancelled(e) {
        const markAsCancelledUrl = e.target.dataset.subscriptionMarkAsCancelledUrl;

        this.loadingIndicatorTarget.classList.remove("hidden");
        const xmlHttp = new XMLHttpRequest();
        xmlHttp.onreadystatechange = () => {
            if (xmlHttp.readyState === 4) {
                if (xmlHttp.status === 200) {
                    location.reload();
                } else {
                    console.warn(xmlHttp.status);
                    console.warn(xmlHttp.response);
                }
            }
        };
        xmlHttp.open("POST", markAsCancelledUrl);
        xmlHttp.setRequestHeader("Content-Type", "application/json");
        xmlHttp.send(JSON.stringify({}));
    }

    get createNewUrl() {
        return this.data.get("createNewUrl");
    }

}
